import { nodeApiClient, nodeApiRoutes } from 'common/services';
import type { NodeUserDataObject } from 'models/service';

export const getNodeUser = async () => nodeApiClient.get<NodeUserDataObject>(nodeApiRoutes.users.profile);
